import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import useSecurity from "../hooks/useSecurity";

const PublicRoutes = () => {
  const { isAuthenticated } = useSecurity();
  const role = useSelector((state) => state.authentication.role);
  const isRoleAdmin = role === "admin";
  const landingRoute =
    role === "client"
      ? "/client-portal"
      : role === "rep" && !isRoleAdmin
        ? "/rep-home"
        : "/home";

  return !isAuthenticated ? <Outlet /> : <Navigate to={landingRoute} />;
};

export default PublicRoutes;
